export default {
  data () {
    return {
      isTrue: (message) => {
        return v => (v === true) || (message || 'Campo requerido')
      },
      isRequired: (message) => {
        return v => {
          if (v && Object.keys(v).length > 0) {
            return true
          }
          return (!!v && v.length > 0) || (message || 'Campo requerido')
        }
      },
      isEmail: v => {
        if (!v.length > 0) return true
        let regex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
        return regex.test(v) || 'Correo electrónico no válido'
      },
      isComposedBy: (option, value) => {
        let regex = {
          'letters|numbers': /^[A-zÀ-ÖØ-öø-ÿ0-9]*[A-zÀ-ÖØ-öø-ÿ0-9][A-zÀ-ÖØ-öø-ÿ0-9]*$/,
          'letters|numbers|spaces': /^[A-zÀ-ÖØ-öø-ÿ0-9 ]*[A-zÀ-ÖØ-öø-ÿ0-9][A-zÀ-ÖØ-öø-ÿ0-9 ]*$/,
          'numbers': /^[0-9]*[0-9][0-9]*$/
        }
        let msg = {
          'letters|numbers': 'Solo números y letras están permitidos',
          'letters|numbers|spaces': 'Solo números, letras y espacios están permitidos',
          'numbers': 'Solo números están permitidos'
        }
        if (typeof value !== 'undefined' && typeof value === 'string') {
          return v => regex[option].test(v[value]) || msg[option]
        } else if (typeof value !== 'undefined') {
          return v => v.every(value => regex[option].test(value)) || msg[option]
        } else if (typeof value === 'undefined') {
          return v => regex[option].test(v) || msg[option]
        }
        return true
      },
      hasLength: (chars, value) => {
        let msg = 'Debe contener ' + chars + ' caracteres'
        if (typeof value !== 'undefined' && typeof value === 'string') {
          return v => v[value].length === chars || msg
        } else if (typeof value !== 'undefined') {
          return v => v.every(value => value.length === chars) || msg
        } else if (typeof value === 'undefined') {
          return v => (!!v && v.length === chars) || msg
        }
        return true
      },
      hasMaxLength: (chars, value) => {
        let msg = 'No debe exceder de ' + chars + ' caracteres'
        if (typeof value !== 'undefined' && typeof value === 'string') {
          return v => v[value].length <= chars || msg
        } else if (typeof value !== 'undefined') {
          return v => v.every(value => value.length <= chars) || msg
        } else if (typeof value === 'undefined') {
          return v => v.length <= chars || msg
        }
        return true
      },
      hasMinLength: (chars, value) => {
        let msg = 'Debe contener un mínimo de ' + chars + ' caracteres'
        if (typeof value !== 'undefined' && typeof value === 'string') {
          return v => v[value].length >= chars || msg
        } else if (typeof value !== 'undefined') {
          return v => v.every(value => value.length >= chars) || msg
        } else if (typeof value === 'undefined') {
          return v => v.length >= chars || msg
        }
        return true
      }
    }
  },

  methods: {

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setRules (rules, value) {
      let items = []
      for (let rule in rules) {
        rule = rules[rule].split(':')
        switch (rule[0]) {
          case 'required':
            items.push(this.isRequired(rule[1] || null))
            break
          case 'is_true':
            items.push(this.isTrue(rule[1] || null))
            break
          case 'has_length':
            items.push(this.hasLength(parseInt(rule[1]), value))
            break
          case 'has_min_length':
            items.push(this.hasMinLength(parseInt(rule[1]), value))
            break
          case 'has_max_length':
            items.push(this.hasMaxLength(parseInt(rule[1]), value))
            break
          case 'is_composed_by':
            items.push(this.isComposedBy(rule[1]))
            break
          case 'is_email':
            items.push(this.isEmail)
            break
        }
      }
      return items
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/rule.js